import { Navigate } from 'react-router-dom';
import { useAuth } from "@zones-digital-platform/react-oidc-auth";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;